import React from "react";
import Seo from "../components/Seo";
import "../styles/pages/service-detail.css";

function SecureTransport() {
    return (
        <main className="page">
            <Seo
                title="Secure Transport Services"
                path="/services/secure-transport"
                description="Professional secure transport services with safeguarding, comfort, dignity, and structured support at the centre of every journey."
                keywords="secure transport services, safe patient transport, supported transport, safeguarding transport"
            />

            <div className="container service-detail">
                <div className="service-hero-card">
                    <p className="eyebrow">Secure Transport</p>
                    <h1>Professional transport arrangements with safety and dignity in focus</h1>
                    <p>
                        We deliver safe and dignified transport solutions for individuals who require structured, secure, and professionally managed transfers.
                    </p>
                </div>
                <div className="detail-grid">
                    <div className="info-card">
                        <h2>Safe Journeys</h2>
                        <p>Every journey is planned with safeguarding, communication, supervision, and comfort in mind.</p>
                    </div>
                    <div className="info-card">
                        <h2>Professional Delivery</h2>
                        <p>We prioritize punctuality, respectful support, and reliable transfer arrangements across every booking.</p>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default SecureTransport;